module.exports = __webpack_public_path__ + "img/Lapto-2-p-1080.05ef0c99.png";